import React, { useEffect, useState } from 'react'
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { ApiGetCall, ApiGetCallAuthKey, ApiPostCall } from '../../JS/Connector';
import { GetAllGroups, LogInSchoolID, formatDateToUsaMMDDYYYY, getAllBuildings, getAllUsers, getTypeWatchDelay, typewatch } from '../../JS/Common';
import { useLocation, useNavigate } from 'react-router-dom';
import { faUser, faUsers } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AlertsComp from '../../Components/AlertsComp';
import Pagination from 'react-js-pagination';
import PageHead from '../../Components/PageHead';
import Popup from '../../Components/Popup';
import Deletepopup from '../../Components/Deletepopup';
import Tab from '../../Components/Tab';
import { CheckValidation } from '../../Components/Validations';
import useConfig from '../../Hooks/useConfig';

export default function HdticketAssignments() {
    const { dynamic_brand_text } = useConfig();
    const navigate = useNavigate();
    const location = useLocation();
    const [SearchString, setSearchString] = useState('');
    const [flag, setFlag] = useState(0);
    const [Ispopup, setIspopup] = useState(false);
    const [GridData, setGridData] = useState([]);
    const [BuildingData, setBuildingData] = useState([]);
    const [HelpdeskType, setHelpdeskType] = useState([]);
    const [HelpdeskCategories, setHelpdeskCategories] = useState([]);
    const [AllUsers, setAllUsers] = useState([]);
    const [SelectedIdsAll, setSelectedIdsAll] = useState([]);
    const [AllGroups, setAllGroups] = useState([]);
    const [loading, setLoading] = useState(false);
    const [Alerts, setAlerts] = useState("");
    const [assignedflag, setassignedflag] = useState(0);
    const [ErrorMsg, setErrorMsg] = useState('');
    const [Values, setValues] = useState({
        buildingId: '0',
        CategoryId: '0',
        HDtypeid: '0'
    });
    const [allData, setAllData] = useState({
        SortbyFlag: 'asc',
        searchstring: '',
        SortbyKey: ''
    })
    const [selectedUserId, setSelectedUserId] = useState(0)
    const [selectedGroupId, setSelectedGroupId] = useState(0)
    const [TicketAssignmentId, setTicketAssignmentId] = useState('')
    const [currentPage, setCurrentPage] = useState(1);
    const [LimitForPagination, setLimitForPagination] = useState(25);
    const [pageRangeCount, setpageRangeCount] = useState(0);
    const showPagination = GridData.length > 0;
    const [GroupInfo, setGroupInfo] = useState({
        groupid: '',
        groupname: '',
        users: [],
        loader: false
    });
    const [showPopover, setShowPopover] = useState(false);
    const [selectedItemId, setSelectedItemId] = useState(null);
    const [DeletePopup, setDeletePopup] = useState(false);
    const [GroupDeletePopup, setGroupDeletePopup] = useState(false);
    const [GropuInfoModal, setGropuInfoModal] = useState(false);
    const [GroupId, setGroupId] = useState('');
    const [UserId, setUserId] = useState('');
    const [DeleteAssignmentId, setDeleteAssignmentId] = useState('');
    const [GridTabs, setGridTabs] = useState(() => {
        const openUserGroups = location.state?.openUserGroups;
        if (openUserGroups) {
            navigate(location.pathname, { replace: true });
        }
        return {
            TicketAssignmentTab: openUserGroups ? '' : 'active',
            UserGroupsTab: openUserGroups ? 'active' : ''
        };
    });

    useEffect(() => {
        if (GridTabs.TicketAssignmentTab == 'active') {
            GetGridData(SearchString ? SearchString : null);
        } else {
            GetUsers(null, null, false);
        }
    }, [currentPage, LimitForPagination]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (showPopover && !event.target.closest('.popover')) {
                setShowPopover(false);
            }
        };
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [showPopover]);

    async function GetUsers(searchstring, sortkey, toogleSort) {
        if (!searchstring) searchstring = null;
        if (sortkey && toogleSort) allData.SortbyFlag = allData.SortbyFlag == "asc" ? "desc" : "asc";
        setAllData({ ...allData, SortbyKey: sortkey });
        typewatch(async function () {
            setLoading(true);
            await ApiGetCall(`/helpdesk/groups/all?schoolId=${LogInSchoolID}&search=${searchstring}&sortBy=${sortkey}&sortByOrder=${allData.SortbyFlag}&page=${currentPage}&limit=${LimitForPagination}`).then((result) => {
                if (result == undefined || result == "") {
                    alert("Something went wrong");
                } else {
                    const responseRs = JSON.parse(result);
                    setLoading(false);
                    setpageRangeCount(responseRs.msg.total)
                    setGridData(responseRs.msg.data.length ? responseRs.msg.data : []);
                }
            });
        }, getTypeWatchDelay(searchstring, 500));
    }

    async function GetGroupInfo(gid) {
        setLoading(true);
        await ApiGetCall(`/helpdesk/groups/by-id?schoolId=${LogInSchoolID}&groupId=${gid}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                var msg = responseRs.msg;
                setLoading(false);
                if (msg != null) {
                    setGroupInfo({ ...GroupInfo, groupid: msg.id, groupname: msg.name, users: responseRs.users });
                }
                getAllUsers(setAllUsers);
            }
        })
    }

    async function GetGridData(searchstring) {
        if (searchstring == "" || searchstring == undefined) {
            searchstring = null;
        }
        typewatch(async function () {
            setLoading(true);
            await ApiGetCall(`/helpdesk/assignments/all?schoolId=${LogInSchoolID}&search=${searchstring}&page=${currentPage}&limit=${LimitForPagination}`).then((result) => {
                if (result == undefined || result == "") {
                    alert("Something went wrong");
                } else {
                    setLoading(false);
                    const responseRs = JSON.parse(result);
                    setpageRangeCount(responseRs?.pagination_total)
                    if (responseRs.data.length != 0) {
                        setGridData(responseRs.data);
                    } else {
                        setGridData([])
                    }
                }
            });
        }, 500);
    }
    function GetAllHdTypes(flag, hdtypeid, foreditflag) {
        ApiGetCallAuthKey(`/helpdesk/data-by-id?schoolId=${LogInSchoolID}&uuid=${hdtypeid}&flag=${flag}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                setLoading(false);
                if (responseRs.length != 0) {
                    if (flag == 3) {
                        setHelpdeskType(responseRs);
                        if (foreditflag == 1) {
                            GetAllHdTypes(4, hdtypeid, 0);
                            setHelpdeskCategories(responseRs)
                        }
                    } else if (flag == 4) {
                        setHelpdeskCategories(responseRs)
                    }
                }
                else {
                    if (flag == 3) {
                        setHelpdeskType([]);
                    } else if (flag == 4) {
                        setHelpdeskCategories([])
                    }
                }
            }
        });
    }
    function handleChangeForUsers(e, selectedid) {
        setSelectedUserId(selectedid);
        setSelectedGroupId(0);
    }

    function handleChangeForGroups(e, selectedid) {
        setSelectedGroupId(selectedid);
        setSelectedUserId(0);
    }

    async function handleSaveUpdate(flag) {
        var raw = JSON.stringify({
            schoolId: LogInSchoolID,
            buildingId: Values.buildingId,
            hdTypeId: Values.HDtypeid,
            hdCategoryId: Values.CategoryId,
            assignedFlag: assignedflag,
            assignedId: assignedflag == 1 ? selectedGroupId : selectedUserId,
            uuid: flag == 1 ? 0 : TicketAssignmentId
        });
        if (Values.buildingId == '' || Values.buildingId == '0') {
            setErrorMsg('Building is required');
            return
        } else if (assignedflag == 0) {
            setErrorMsg('what are you assigned to in this building?');
            return
        } else if (assignedflag == 1 && selectedGroupId == 0) {
            setErrorMsg('Select at least one group');
            return
        } else if (assignedflag == 2 && selectedUserId == 0) {
            setErrorMsg('Select at least one user');
            return
        } else {
            setErrorMsg('');
        }
        await ApiPostCall("/helpdesk/assignments/save-many", raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                const responseRs = JSON.parse(result)
                if (responseRs.response == "success") {
                    setAlerts(<AlertsComp show={true} variant="success" msg={`Help Desk Ticket Assignments ${flag == 1 ? 'Added' : 'Updated'} Successfully`} />);
                    setTimeout(() => {
                        setIspopup(false)
                        setAlerts(<AlertsComp show={false} />);
                        GetGridData(SearchString ? SearchString : null)
                        setassignedflag(0); setErrorMsg(''); setHelpdeskType([]); setHelpdeskCategories([]); setValues({ ...Values, buildingId: '0', CategoryId: '0', HDtypeid: '0' }); setAllUsers([])
                    }, 1500);
                }
                else {
                    setAlerts(<AlertsComp show={true} variant="danger" msg={responseRs.msg} />);
                    setTimeout(() => {
                        setAlerts(<AlertsComp show={false} />);
                    }, 1500);
                }
            }
        });
    }
    function handleAssignChange(flag) {
        setassignedflag(flag);
        if (flag == 1) {
            GetAllGroups({ setLoading, setAllGroups });
        } else {
            getAllUsers(setAllUsers);
        }
        setSelectedUserId(0);
        setSelectedGroupId(0);
    }

    async function GetAssignmentDataById(GridID) {
        setLoading(true)
        await ApiGetCall(`/helpdesk/assignments/by-id?schoolId=${LogInSchoolID}&uuid=${GridID}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                setValues({ ...Values, buildingId: responseRs[0]?.building_id, CategoryId: responseRs[0]?.hd_category_id, HDtypeid: responseRs[0]?.hd_type_id })
                setassignedflag(responseRs[0]?.assigned_flag)
                getAllBuildings(setBuildingData, LogInSchoolID);
                GetAllHdTypes(3, responseRs[0]?.hd_type_id, 1);
                if (responseRs[0]?.assigned_flag == 1) {
                    GetAllGroups({ setLoading, setAllGroups });
                    setSelectedGroupId(responseRs[0]?.assigned_id)
                } else {
                    getAllUsers(setAllUsers);
                    setSelectedUserId(responseRs[0]?.assigned_id)
                }
                setLoading(false);
            }
        });
    }
    async function GetGroupinfoById(gid) {
        setGroupInfo({ ...GroupInfo, loader: true });
        await ApiGetCall(`/helpdesk/groups/by-id?schoolId=${LogInSchoolID}&groupId=${gid}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                var msg = responseRs.msg;
                if (responseRs.length != 0) {
                    setGroupInfo({ ...GroupInfo, groupid: msg.id, groupname: msg.name, users: responseRs.users, loader: false });
                    setShowPopover(true);
                }
                else {
                    setGroupInfo([]);
                }
            }
        })
    }
    const popover = (
        <Popover id="popover-basic" style={{ maxWidth: '50%', fontSize: '14px' }} onMouseLeave={() => setShowPopover(false)}>
            <Popover.Header as="h3">Users</Popover.Header>
            <Popover.Body style={{ margin: '0 10px' }}>

                {!GroupInfo?.loader ?
                    GroupInfo?.users?.length > 0 ? (
                        GroupInfo?.users?.map((item, i) => {
                            var returData = (
                                <li>{item.first_name + ' ' + item.last_name}</li>
                            )
                            return returData;
                        })
                    ) :
                        <li>No Record Found</li>
                    : <div className='row px-2'>
                        <div className="text-center">
                            <img src="/images/loder.svg" className="" style={{ width: "30px" }} />
                        </div>
                    </div>
                }

            </Popover.Body>
        </Popover>
    );

    const handleToggle = (nextShow, itemId) => {
        typewatch(async function () {
            if (nextShow) {
                setSelectedItemId(itemId);
                GetGroupinfoById(itemId)
            } else {
                setSelectedItemId(null);
                setGroupInfo({ ...GroupInfo, users: [] });
            }
        }, 500);
    };
    function handleSearchChange(e) {
        setSearchString(e.target.value);
        setCurrentPage(1);
        if (GridTabs.TicketAssignmentTab == "active") {
            GetGridData(e.target.value)
        } else {
            GetUsers(e.target.value, null, false)
        }
    }
    const modalbody = (
        <>
            <div className="px-3" >
                <div className='row pb-2 align-items-center'>
                    <div className="col-md-6">Building Name : </div>
                    <div className='col-md-6'>
                        {flag == 1 ?
                            <select value={Values.buildingId} onChange={(e) => {
                                setValues({ ...Values, buildingId: e.target.value });
                                GetAllHdTypes(3, null, 0);
                            }}>
                                <option value='0'>Select</option>
                                {BuildingData?.map((item) => (
                                    <option key={item.id} value={item.id}>
                                        {item.name}
                                    </option>
                                ))}
                            </select>
                            :
                            <select disabled value={Values.buildingId}>
                                <option value='0'>Select</option>
                                {BuildingData?.map((item) => (
                                    <option key={item.id} value={item.id}>
                                        {item.name}
                                    </option>
                                ))}
                            </select>
                        }

                    </div>
                </div>
                <div className={`row py-2 align-items-center ${Values.buildingId != "0" ? '' : 'd-none'} `}>
                    <div className="col-md-6">Help Desk Type : </div>
                    <div className='col-md-6'>
                        {flag == 1 ?
                            <select className="form-select" value={Values.HDtypeid} onChange={(e) => { setValues({ ...Values, HDtypeid: e.target.value }); GetAllHdTypes(4, e.target.value, 0); }}  >
                                <option value='0'>All</option>
                                {HelpdeskType?.map((item) => (
                                    <option key={item.id} value={item.id}>
                                        {item.name}
                                    </option>
                                ))}
                            </select>
                            :
                            <select className="form-select" disabled value={Values.HDtypeid} >
                                <option value='0'>All</option>
                                {HelpdeskType?.map((item) => (
                                    <option key={item.id} value={item.id}>
                                        {item.name}
                                    </option>
                                ))}
                            </select>
                        }
                    </div>
                </div>
                <div className={`row py-2 align-items-center ${Values.HDtypeid != "0" ? '' : 'd-none'} `}>
                    <div className="col-md-6">Help Desk Category : </div>
                    <div className='col-md-6'>
                        <select className="form-select" value={Values.CategoryId} onChange={(e) => { setValues({ ...Values, CategoryId: e.target.value }); }}  >
                            <option value='0'>All</option>
                            {HelpdeskCategories?.map((item) => (
                                <option key={item.id} value={item.id}>
                                    {item.name}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className={`row mt - 2`}>
                    <hr className='my-2' />
                    <div className='col-12'>
                        <b className='h5'>Assigned to : </b>
                    </div>
                    <hr className='my-2' />
                    <div className='greyBox mt-2'>
                        <div className='row align-items-center'>
                            <div className='col-12 d-flex justify-content-around'>
                                <div className="form-check">
                                    <input className="form-check-input" type="radio" name='assigned' checked={assignedflag == 1 ? true : false} onChange={(e) => handleAssignChange(1)} />
                                    <b className="form-check-label ps-1 FormLabel">
                                        Group
                                    </b>
                                </div>
                                <div className="form-check ms-5">
                                    <input className="form-check-input" type="radio" name='assigned' checked={assignedflag == 2 ? true : false} onChange={(e) => handleAssignChange(2)} />
                                    <b className="form-check-label ps-1 FormLabel">
                                        Individual
                                    </b>
                                </div>
                            </div>
                        </div>
                        <div className='row pt-2 '>
                            {assignedflag == 2 ?
                                <>
                                    <hr />
                                    {AllUsers.length > 0 ?
                                        AllUsers.map((item, i) => {
                                            return <div className="col-md-4 py-2 FormLabel" key={i}>
                                                <input type="radio"
                                                    className="form-check-input me-2"
                                                    onChange={(e) => handleChangeForUsers(e, item.id)}
                                                    name="users"
                                                    checked={selectedUserId === item.id} />
                                                {item.name}
                                            </div>
                                        })
                                        :
                                        <div className='col-12 text-center'>
                                            No Record Found
                                        </div>
                                    }

                                </>
                                : assignedflag == 1 ?
                                    <>
                                        <hr />
                                        {AllGroups.length > 0 ?
                                            AllGroups.map((item, i) => {
                                                return <div className="col-md-4 py-2 d-flex FormLabel" key={i}>
                                                    <input type="radio"
                                                        className="form-check-input me-2"
                                                        onChange={(e) => handleChangeForGroups(e, item.id)}
                                                        name="groups"
                                                        checked={selectedGroupId === item.id}
                                                    />
                                                    {item.name}
                                                    <div className="ps-2" key={item.id}>
                                                        <OverlayTrigger
                                                            trigger="hover"
                                                            placement="bottom"
                                                            show={showPopover && selectedItemId == item.id}
                                                            onToggle={(nextShow) => handleToggle(nextShow, item.id)}
                                                            overlay={popover}
                                                        >
                                                            <a href="#" role="button">
                                                                <img src="/images/InfoBtn.svg" className="cursor-pointer" height='13px' />
                                                            </a>
                                                        </OverlayTrigger>
                                                    </div>
                                                </div>
                                            })
                                            :
                                            <div className='col-12 text-center'>
                                                No Record Found
                                            </div>
                                        }
                                    </>
                                    :
                                    <></>
                            }
                        </div>
                    </div>
                </div>
            </div>
            <div className='ps-3 mt-2 redText'>{ErrorMsg}</div>
        </>
    )
    async function DeleteTicketAssignment() {
        setLoading(true);
        var raw = JSON.stringify({
            schoolId: LogInSchoolID,
            uuid: DeleteAssignmentId,
        });
        await ApiPostCall("/helpdesk/assignments/delete", raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                setLoading(false);
                setDeletePopup(false);
                if (responseRs.status == "success") {
                    setAlerts(<AlertsComp show={true} variant="success" msg={"Assignment Deleted Successfully."} />);
                    setTimeout(() => {
                        GetGridData(null);
                        setAlerts(<AlertsComp show={false} />)
                    }, 1500);
                } else {
                    setAlerts(<AlertsComp show={true} variant="danger" msg={responseRs.msg} />);
                    setTimeout(() => {
                        setAlerts(<AlertsComp show={false} />);
                    }, 2000);
                }
            }
        });
    }

    const GroupInfoModalBody = (
        <div id="GroupModelId" className='parent'>
            <div className='col-12'>
                <input type="text" required autoComplete='off' name='groupname' className="form-control" value={GroupInfo.groupname}
                    onChange={(e) => setGroupInfo({ ...GroupInfo, groupname: e.target.value })} />
                <span className="form-text invalid-feedback">
                    *required
                </span>
            </div>
            <div className='col-12 pt-2'>
                <div className='col-12 text-end'>
                    <label className='redText font-12'>*Existing Users</label>
                </div>
                <div className="greyBox">
                    <table className="table">
                        <thead className="GridHeader">
                            <tr>
                                <th scope="col" className="fw-600 text-start">User Name</th>
                                <th scope="col" className="fw-600 text-start">Email</th>
                                <th scope="col" className="fw-600 text-start">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {AllUsers?.length != null ? (
                                GroupInfo.users?.map((groupUser, i) => {
                                    return (
                                        <tr key={groupUser.id} className={`OddEvenClass tableBorderHide custom-text-danger`}>
                                            <td className="py-12 text-start"> {groupUser.first_name + ' ' + groupUser.last_name} </td>
                                            <td className="py-12 text-start">{groupUser.email || '-'}   </td>
                                            <td className='text-center py-12'>
                                                <img src='/images/RedDelete.svg' title='Delete this user from group' style={{ height: "18px" }}
                                                    className='cursor-pointer' onClick={() => { handleDeleteFromModal(groupUser.id); }} />
                                            </td>
                                        </tr>
                                    );
                                }).concat(
                                    AllUsers
                                        .filter(user => !GroupInfo.users?.some(groupUser => groupUser.id === user.id))
                                        .map((item, i) => {
                                            return (
                                                <tr key={item.id} className={`OddEvenClass tableBorderHide`}>
                                                    <td className="py-12 text-start"> {item.name} </td>
                                                    <td className="py-12 text-start">{item.email || '-'}   </td>
                                                    <td className='text-center py-12'>
                                                        <input type="checkbox" title="Add user" className="form-check-input cursor-pointer" name="user"
                                                            onChange={(e) => handleCheckboxChange(e, item.id)} />
                                                    </td>
                                                </tr>
                                            );
                                        })
                                )
                            ) :
                                <tr><td colspan={3} className="text-center"> No Record Found </td> </tr>
                            }

                        </tbody>

                    </table>
                </div>
                <label className='font-12 redText pt-3'>{ErrorMsg}</label>
                {ErrorMsg != '' && (
                    <div className='col-12 text-center'>
                        <label className="ms-2 cursor-pointer" onClick={(e) => FinalDeleteUser(2, UserId)}><u>Yes</u></label>
                        <label className="ms-3 cursor-pointer" onClick={() => { setErrorMsg('') }}><u>No</u></label>
                    </div>
                )}
            </div>
        </div>
    )

    async function handleDeleteFromModal(userid) {
        setUserId(userid);
        if (GroupInfo.users.length == 1) {
            setErrorMsg('This is the last active user in this group. If you delete this user, the group will be automatically removed, and any tickets assigned to it will be unassigned. Are you sure you want to proceed?');
            return;
        } else {
            FinalDeleteUser(1, userid);
        }
    }

    function handleCheckboxChange(e, ID) {
        const isChecked = e.target.checked;
        setSelectedIdsAll((prevIds) => {
            if (isChecked) {
                return [...prevIds, ID];
            } else {
                return prevIds.filter((id) => id !== ID);
            }
        });
    }

    function handleTabClick(tabType) {
        setCurrentPage(1);
        setGridData([]);
        setErrorMsg('')
        if (tabType == "TicketAssignmentTab") {
            setGridTabs({ ...GridTabs, TicketAssignmentTab: "active", UserGroupsTab: '' });
            GetGridData(null);
        } else if (tabType == "UserGroupsTab") {
            setGridTabs({ ...GridTabs, TicketAssignmentTab: "", UserGroupsTab: 'active' });
            GetUsers(null, null, false);
        }
    }

    async function DeleteGroup() {
        setLoading(true);
        var raw = "";
        await ApiPostCall("/helpdesk/groups/delete/" + LogInSchoolID + "&" + GroupId, raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                setLoading(false);
                if (responseRs.status == "success") {
                    setAlerts(<AlertsComp show={true} variant="success" msg={"Group Deleted Successfully."} />);
                    setTimeout(() => {
                        setGroupDeletePopup(false);
                        GetUsers(null, null, false);
                        setAlerts(<AlertsComp show={false} />)
                    }, 1500);
                } else {
                    setAlerts(<AlertsComp show={true} variant="danger" msg={responseRs.msg} />);
                    setTimeout(() => {
                        setAlerts(<AlertsComp show={false} />);
                    }, 2000);
                }
            }
        });
    }

    async function FinalDeleteUser(flag, userid) {
        var raw = JSON.stringify({
            schoolId: LogInSchoolID,
            groupId: GroupInfo.groupid,
            userId: userid,
            flag: flag //1 -> more than one user 2->last user
        });
        await ApiPostCall("/helpdesk/groups/remove-user", raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                if (result == "success") {
                    setAlerts(<AlertsComp show={true} variant="success" msg={"User Deleted Successfully."} />);
                    setTimeout(() => {
                        setAlerts(<AlertsComp show={false} />);
                        if (flag == 1) {
                            GetGroupInfo(GroupInfo.groupid)
                        } else {
                            setGropuInfoModal(false);
                            GetUsers(allData.searchstring || null, allData.SortbyKey || null, false);
                        }
                    }, 1500);
                }
                else {
                    setAlerts(<AlertsComp show={true} variant="danger" msg={result} />);
                    setTimeout(() => {
                        setAlerts(<AlertsComp show={false} />);
                    }, 2000);
                }
            }
        });
    }

    async function handleSaveGroup() {
        const joinedIds = SelectedIdsAll.join(',');
        var isFormValid = CheckValidation({ formID: 'GroupModelId' });
        if (!isFormValid) return;
        setLoading(true);
        var raw = JSON.stringify({
            schoolId: LogInSchoolID,
            groupName: GroupInfo.groupname,
            groupId: GroupInfo.groupid,
            groupUserId: SelectedIdsAll
        });
        await ApiPostCall("/helpdesk/groups/save", raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                const responseRs = JSON.parse(result)
                if (responseRs.response == "success") {
                    setAlerts(<AlertsComp show={true} variant="success" msg={"Group Updated Successfully."} />);
                    setGropuInfoModal(false);
                    setTimeout(() => {
                        setAlerts(<AlertsComp show={false} />);
                        GetUsers(allData.searchstring || null, allData.SortbyKey || null, false);
                    }, 1500);
                }
                else {
                    setAlerts(<AlertsComp show={true} variant="danger" msg={responseRs.msg} />);
                    setTimeout(() => {
                        setAlerts(<AlertsComp show={false} />);
                    }, 2000);
                }
            }
        });
    }

    return (
        <div>
            <PageHead LimitForPagination={LimitForPagination} setLimitForPagination={setLimitForPagination}
                setCurrentPage={setCurrentPage} heading={"Help Desk Ticket Assignments"} handleSearch={handleSearchChange}
                loading={loading} Alerts={Alerts} showsearch={true} />
            {GridTabs.TicketAssignmentTab == 'active' &&
                <div className='row align-items-center pe-0'>
                    <div className='col-md-12 py-2 text-end'>
                        <label className='BorderBtn' onClick={(e) => { setFlag(1); setIspopup(true); getAllBuildings(setBuildingData, LogInSchoolID); }} title={`Assign ${dynamic_brand_text} Users`}>
                            <img src='/images/AddInventory.svg' className='img-fluid px-2' />Assign {dynamic_brand_text} Users
                        </label>
                        <label className='BorderBtn ms-2' onClick={(e) => navigate('/staff-members')} title={`Edit ${dynamic_brand_text} Users`}>
                            <img src='/images/AddInventory.svg' className='img-fluid px-2' />Edit {dynamic_brand_text} Users
                        </label>
                    </div>
                </div>
            }
            <div className="GridBox mt-2 p-3" >
                <div className='row pb-3'>
                    <div className='col-md-7'>
                        <ul className="nav nav-tabs">
                            <Tab isActive={GridTabs.TicketAssignmentTab == 'active'}
                                label="Ticket Assignments" onClick={() => handleTabClick('TicketAssignmentTab')} col={'col-md-4'} />
                            <Tab isActive={GridTabs.UserGroupsTab == 'active'}
                                label="User Groups" onClick={() => handleTabClick('UserGroupsTab')} col={'col-md-4'} />
                        </ul>
                    </div>
                    <div className="col-md-5">
                        <div className="d-flex justify-content-end align-items-center font-13">
                            {GridTabs.TicketAssignmentTab == 'active' &&
                                <>
                                    <div className={`d-flex align-items-center`}>
                                        <div className="setup-status-square mx-3" style={{ backgroundColor: '#eff4ff' }}></div><span>Assign to Group</span>
                                    </div>
                                    <div className={`d-flex align-items-center`}>
                                        <div className="setup-status-square mx-3" style={{ backgroundColor: '#e7fef6' }}></div><span>Assign to Individual</span>
                                    </div>
                                </>
                            }
                            {GridTabs.UserGroupsTab == 'active' &&
                                <label className='BorderBtn text-center marginDetailsPopup' title='Create Group' onClick={() => navigate('/staff-members')}>
                                    <img src='/images/AddInventory.svg' className='img-fluid pe-2' alt='Add Group' />
                                    Create Group
                                </label>
                            }
                        </div>
                    </div>
                </div>
                <div className={`greyBox p-3 ${GridTabs.TicketAssignmentTab == 'active' ? "data-table-container" : ""}`}>
                    {GridTabs.TicketAssignmentTab == 'active' ?
                        <div className='row g-4 g-lg-4 pb-3'>
                            {GridData.length !== 0 ? (
                                GridData.map((item, i) => {
                                    return (
                                        <div className='col-md-4'>
                                            <div className='p-3 GridBox boxshaowstyle' style={{ maxHeight: '100%', minHeight: '100%', backgroundColor: item.assigned_flag == 2 ? "#e7fef6" : '#eff4ff' }}>
                                                <img src="/images/NewEditIconn.svg" className="cursor-pointer" title='Edit Help Desk Ticket Assignments' style={{ float: 'right' }} height='16px' onClick={(e) => { setFlag(2); setTicketAssignmentId(item.id); GetAssignmentDataById(item.id); setIspopup(true) }} />
                                                <img src="/images/DeleteIcon.svg" title="Delete Ticket Assignment" className="img-fluid cursor-pointer pe-2" style={{ float: 'right' }} height='16px'
                                                    onClick={(e) => { setDeletePopup(true); setDeleteAssignmentId(item.id) }} />
                                                <h4 className='mb-0 mt-1 fw-600 text-break' style={{ color: 'var(--primary-color)', fontSize: '24px' }}>{item.building_id}</h4>
                                                <div className='mt-3' style={{ fontSize: '14px', color: '#4C5258' }}>Type : <label className='fw-600'>{item.hdtype == null ? 'All' : item.hdtype}</label></div>
                                                <div className='mt-2' style={{ fontSize: '14px', color: '#4C5258' }}>Category : <label className='fw-600'>{item.hdcategory == null && item.hdtype != null ? 'All' : item.hdcategory == null && item.hdtype == null ? '-' : item.hdcategory}</label></div>
                                                <div className='d-flex align-items-center'>
                                                    <div className='mt-3'>{item.assigned_flag == 2 ? <FontAwesomeIcon icon={faUser} /> : <FontAwesomeIcon icon={faUsers} />}</div>
                                                    <div className='fw-600 mt-3 ps-2' style={{ fontSize: '16px', color: '#4C5258' }}>{item.assignid}</div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                            ) : (
                                <div className='d-flex align-items-center justify-content-center'>
                                    <img src='/images/TicketAssignmentIcon.svg' />
                                </div>
                            )}
                        </div> :
                        <table className="table data-table">
                            <thead className='GridHeader'>
                                <tr>
                                    <th scope="col" title='Sort by Name' className='fw-600 cursor-pointer' onClick={(e => GetUsers(allData.searchstring, 'name', true))}>Name <img src="/images/sortbynew.svg" alt={`Sort by Name`} className="img-fluid ps-2 sortbyClass" /></th>
                                    <th scope="col" className='fw-600'>No. of Users</th>
                                    <th scope="col" title='Sort by Created At' className='fw-600 cursor-pointer' onClick={(e => GetUsers(allData.searchstring, 'created_at', true))}>Created at <img src="/images/sortbynew.svg" alt={`Sort by Created at`} className="img-fluid ps-2 sortbyClass" /></th>
                                    <th scope="col" className='fw-600 text-center'>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {GridData.length != 0 ?
                                    GridData.map((item, i) => {
                                        const userid = item?.user_id?.split(',');
                                        const count = userid?.length;
                                        return <tr key={i} className="OddEvenClass tableBorderHide">
                                            <td scope="col" className='py-12'>{item.name}</td>
                                            <td scope="col" className='py-12'>{count}</td>
                                            <td scope="col" className='py-12'>{item.created_at ? formatDateToUsaMMDDYYYY(item.created_at) : '-'}</td>
                                            <td scope="col" className='text-center py-12'>
                                                <img src='/images/EditIconNew.svg' title='Edit Group' className='img-fluid pe-2 cursor-pointer' onClick={(e) => { setGropuInfoModal(true); setSelectedIdsAll([]); GetGroupInfo(item.id) }} />
                                                <img src="/images/DeleteIcon.svg" title="Delete Group" className="img-fluid cursor-pointer"
                                                    onClick={(e) => { setGroupDeletePopup(true); setGroupId(item.id) }} />
                                            </td>
                                        </tr>
                                    })
                                    :
                                    <tr className="text-center"> <td colSpan={15}>No Record Found</td> </tr>
                                }
                            </tbody>
                        </table>
                    }
                    {showPagination && (
                        <Pagination activePage={currentPage} totalItemsCount={pageRangeCount}
                            pageRangeDisplayed={15} itemsCountPerPage={LimitForPagination} onChange={(e) => setCurrentPage(e)}
                            color="primary" lastPageText="" firstPageText="" itemClassFirst="MasterClass" itemClassPrev="MasterClass"
                            itemClassNext="MasterClass" itemClassLast="MasterClass" hideFirstLastPages={true} />
                    )}
                </div>
            </div>


            <Deletepopup text={`Are you sure you want to delete this ticket assignment?. You won't be able to revert this!`} deletePopup={DeletePopup} size="xl" deletePart={DeleteTicketAssignment} DeleteShowClose={(e) => setDeletePopup(false)} />

            <Popup isshow={Ispopup} size={"md"} title={flag == 1 ? 'Add Help Desk Ticket Assignments' : 'Update Help Desk Ticket Assignments'}
                closePopup={(e) => { setIspopup(false); setassignedflag(0); setErrorMsg(''); setHelpdeskType([]); setHelpdeskCategories([]); setValues({ ...Values, buildingId: '0', CategoryId: '0', HDtypeid: '0' }); setAllUsers([]) }}
                modalBody={modalbody} handleSave={(e) => handleSaveUpdate(flag)} visibleSaveBtn={true} btnText={flag == 1 ? 'Save' : 'Update'} />

            <Popup isshow={GropuInfoModal} size={"md"} title={"Users Group Details"}
                closePopup={(e) => { setGropuInfoModal(false); GetUsers(allData.searchstring || null, allData.SortbyKey || null, false) }}
                modalBody={GroupInfoModalBody} handleSave={handleSaveGroup} visibleSaveBtn={true} btnText={"Save"} />

            <Deletepopup text={`If you delete this group, all the tickets assigned to it will become unassigned. You won't be able to revert this!`} deletePopup={GroupDeletePopup} size="xl" deletePart={DeleteGroup} DeleteShowClose={(e) => setGroupDeletePopup(false)} />
        </div>
    )
}
